import { useMemo } from "react";
import { IPayment } from "../../../globals/interfaces";

export default function useReceiptRequired (payments: Array<IPayment>, s_unit: string) {
    const receiptRequired = useMemo(() => {
        if (new Set(['CEWR2', 'CEWR3']).has(s_unit)) {
            return true;
        }
        const otherPayment = payments.find(payment => payment.s_payment_type === 'OTHER (RECEIPT REQUIRED)');
        if (otherPayment) {
            return true;
        }
        return false;
    }, [payments, s_unit]);

    return receiptRequired;
}